import WildAppResource from "./WildAppResource";
import UserAppResource from './UserAppResource';
import LuContactTypeAppResource from "./LuContactTypeAppResource";

class ContactAppResource extends WildAppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'contact';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'contacts';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'email',
            'fullName',
            'companyName',
            'userUuid',
            'contactTypeId',
            'modelUuid',
            'meta',
            'uuid'
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            user: UserAppResource,
            modelUser: UserAppResource,
            contactType: LuContactTypeAppResource
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            user: 'user_uuid',
            contactType: 'contact_type_id',
            modelUser: 'model_uuid'
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            email: {
                type: 'string',
                email: true,
                presence: false,
                length: {
                    maximum: 255,
                },
            },
            fullName: {
                type: 'string',
                length: {
                    maximum: 255,
                },
            },
            userUuid: {
                type: 'string',
            },
            modelUuid: {
                type: 'string',
            },            
        };
    }

}

export default ContactAppResource;